<template>
  <div >

        <section >
                <div class="">

                    <div class="row" v-if="!isDetailClient">
                        <div class="col-sm-6">
                            <!-- {{$t('show')}}
                            <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="5">5</option>
                                <option value="10">10</option>
                                <option value="15">15</option>
                                <option value="25">25</option>
                                <option value="50">50</option>
                                <option value="100">100</option>
                            </select>
                            {{$t('entities')}} -->
                        </div>
                        <div class="col-sm-1"></div>
                        <div class="col-sm-1">
                             <select v-model="status" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                                <option value="all">{{$t('all')}}</option>
                                <option value="paid"><span>{{$t('paid')}}</span></option>
                                <option value="partially_paid"><span>{{$t('partially_paid')}}</span></option>
                                <option value="pending"><span>{{$t('pending')}}</span></option>
                                <option value="refunded"><span>{{$t('refunded')}}</span></option>
                            </select>
                        </div>
                        <div class="col-sm-2">
                            <date-picker :clearable="true" :editable="false" style="margin-bottom:1rem;width:100%" v-model="range" type="date" :shortcuts="shortcuts" range :placeholder="$t('select_date_range')"></date-picker>
                        </div>
                        <div class="col-sm-2">
                            <button @click="create" style="width:100%" class="btn btn-sm btn-success align-items-center">
                            <span class="d-inline-block me-2 .text-primary-dark">
                            <PlusIcon class="me-1 client-lucide-icon" :size="15" :stroke-width="1.75" aria-hidden="true" />
                            </span>
                            <span>{{$t('credit_note')}}</span>
                        </button>
                        </div>
                    </div>

                <div class="page-table-container mb-6 bg-white rounded shadow">

                    <!-- table -->
                    <div class="table-responsive">
                        <table class="table mb-0 table-borderless table-striped small">
                            <thead>
                                <tr class="text-secondary">
                                    <sortable-table-header field="reference" label="reference" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('invoice')}}</th>
                                    <sortable-table-header field="total" label="total" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <sortable-table-header field="status" label="status" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <th v-if="!hideClient" class="pt-4 pb-3 px-6">{{$t('client')}}</th>
                                    <sortable-table-header field="date" label="date" :sort-field="sortField" :sort-direction="sortDirection" @sort="applySort($event, getInvoices)" />
                                    <th class="pt-4 pb-3 px-6">{{$t('created_by')}}</th>
                                    <th class="pt-4 pb-3 px-6">{{$t('action')}}</th>
                                </tr>
                            </thead>
                            <tbody>
                            <tr v-for="invoice in invoices" :key="invoice.id">
                                <td class="py-5 px-6"><router-link :to="`/credit-invoices/${invoice.id}`">{{invoice.reference}}</router-link></td>
                                <td class="py-5 px-6"><router-link  v-if="invoice.invoice" :to="`/invoices/${invoice?.invoice?.id}`">{{invoice?.invoice?.reference}}</router-link></td>
                              
                                <td class="py-5 px-6">{{formatMoney(calculateItemPrice(invoice))}}</td>
                                <td class="py-5 px-6">
                                    <span :class="{
                                        'badge bg-success': invoice.status === 'issued',
                                        'badge bg-danger': invoice.status === 'refunded',
                                        'badge bg-secondary': invoice.status === 'draft'
                                        }">
                                        {{ $t(invoice.status) }}
                                        </span>
                                </td>
                                <td v-if="!hideClient" class="py-5 px-6"><router-link v-if="invoice && invoice.client && invoice.client.name" :to="`/clients/${invoice.client.id}`">{{invoice && invoice.client && invoice.client.name ? invoice.client.name : '-'}}</router-link></td>
                                <td class="py-5 px-6">{{formatDate(invoice.date)}}</td>
                                <td class="py-5 px-6">
                                    {{invoice.user ? invoice.user.name : '-'}}
                                </td>
                                <td class="py-5 px-6">
                                   
                                    <button @click="viewRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-eye" class="bi bi-eye" style="font-size:12px" />
                                        {{$t('credit_note')}}
                                    </button>
                                    <button @click="editRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;margin-right:2px" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-pencil" class="bi bi-pencil" style="font-size:12px" />
                                        {{$t('edit')}}
                                    </button>
                                    <button @click="deleteRow(invoice)" style="padding: 5px;margin: 0;font-size: 12px !important;" class="btn btn-primary btn-xs">
                                        <AppIcon name="bi-trash" class="bi bi-trash" style="font-size:12px" />
                                        {{$t('delete')}}
                                    </button>
                                     
                                </td>
                            </tr>
                            <tr v-if="invoices.length" style="background-color: #f8f9fa;font-weight: bold">
                                <td>{{$t('total')}}:</td>
                                <td></td>
                                <td class="py-5 px-6">{{formatMoney(invoices.reduce((acc, item) => acc + calculateItemPrice(item), 0))}} </td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>
                                <td></td>   
                            </tr>
                            </tbody>
                        </table>

                        <div v-if="count > invoices.length" style="text-align:center;margin-top:1rem;margin-bottom:1rem">
                            <compact-pagination :pages="pagination" :current-page="page" @change="getInvoices" />
                        </div>
                    </div>
                    <!-- table -->
                    <table-loading-bar v-if="loading" class="page-table-state text-center" />
                    <div v-if="loading === false && !invoices.length" class="page-table-state text-center" style="padding:1rem">{{$t('no_invoice_found')}}.</div>

                </div>

                <div class="col-sm-6">
                    {{$t('show')}}
                    <select v-model="per_page" class="form-select mb-3" name="Resulats" style="cursor:pointer;margin-right: 5px;width:100px;display:inline-block">
                        <option value="5">5</option>
                        <option value="10">10</option>
                        <option value="15">15</option>
                        <option value="25">25</option>
                        <option value="50">50</option>
                        <option value="100">100</option>
                    </select>
                    {{$t('entities')}}
                </div>
                </div>
        </section>


         <!-- create Modal -->
        <add-edit-invoice-modal 
            v-if="createModalisOpen" 
            @modalClosed="createModalisOpen = false"
            modalId="create-invoice-modal-01" 
            :isModalOpen="createModalisOpen" 
            :data="invoice" 
            action="create"
            @refresh="refresh"
        ></add-edit-invoice-modal>
        <!-- create modal -->

        <!-- Edit Modal -->
        <add-edit-invoice-modal 
            v-if="editModalisOpen" 
            @modalClosed="editModalisOpen = false" 
            modalId="edit-invoice-modal-01" 
            :isModalOpen="editModalisOpen"  
            :data="invoice" 
            action="update" 
            @refresh="refresh"
        ></add-edit-invoice-modal>
        <!-- Edit modal -->

        <!-- quote modal -->
        <invoice-template-modal 
            v-if="invoiceModalisOpen" 
            @modalClosed="invoiceModalisOpen = false" 
            modalId="invoice-invoice-modal-01" 
            :isModalOpen="invoiceModalisOpen"  
            :data="invoice" 
            type="credit-invoice">
        </invoice-template-modal>
        <!-- quote modal -->
  </div>
</template>

<script>
import helper from '../helper'
import moment from 'moment'
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';

import AddEditInvoiceModal from '../components/creditInvoice/AddEditInvoiceModal';
import InvoiceTemplateModal from '../components/invoiceLayout/InvoiceTemplateModal';
import sortableList from '../mixins/sortableList'

export default {
  name: 'CreditInvoice',
  persistedFilterState: {
    key: 'credit-invoices',
    fields: ['status', 'range', 'start', 'end', 'per_page', 'sortField', 'sortDirection'],
    dateFields: ['range'],
  },
  mixins: [sortableList],
  components : {
    DatePicker,
    AddEditInvoiceModal,
    InvoiceTemplateModal
  },
   props : [
    'openCreateModal',
    'client_id',
    'client',
    'order_id',
    'inventory_id',
    'user_id',
    'product_id',
    'invoice_id',
    'products',
    'keyword',
    'isDetailClient'
    ],
  data(){
    return {
        search :'',
        invoices : [],
        count : 0,
        page : 1,
        transactions : [],
        deliveries : [],
        invoice : {
            id : null,
            reference : `I-00`,
            date : '',
            notes : '',
            products : [],
            client_id : null,
            client : {},
            payment_method : 'cash',
            status : 'paid',
            rest : 0,
            total : 0,
            amount_paid : 0,
        },
        range: [],
        start : null,
        end : null,
        shortcuts: [
  {
    text: this.$t('today'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      return [start, end];
    }
  },
  {
    text: this.$t('yesterday'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24);
      end.setTime(end.getTime() - 3600 * 1000 * 24);
      return [start, end];
    }
  },
  {
    text: this.$t('this_week'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    }
  },
  {
    text: this.$t('last_week'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 14);
      end.setTime(end.getTime() - 3600 * 1000 * 24 * 7);
      return [start, end];
    }
  },
  {
    text: this.$t('this_month'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      start.setDate(1);
      return [start, end];
    }
  },
  {
    text: this.$t('last_month'),
    onClick: () => {
      const end = new Date();
      const start = new Date();
      start.setMonth(start.getMonth() - 1);
      start.setDate(1);
      end.setDate(0);
      return [start, end];
    }
  },
],
        createClientState : false,
        status : 'all',
        deliveryProducts : [],
        orderProducts : [],
        totalHtPrice : 0,
        createModal : null,
        editModal : null,
        invoiceModalStatus : false,
        invoiceModalisOpen : false,
        invoiceBlModalisOpen : false,
        createModalisOpen :false,
        showDilveriesModalisOpen : false,
        editModalisOpen :false,
        purchasePrice : 0,
        amount : 0,
        loading : false,
        per_page : 25,
        pagination : [],
        hideClient : false,
        url : ''
    }
  },
  mounted(){
    this.getInvoices()
  },
  watch : {
    range(){

        if(this.range[0] == null){
            this.start = null
            this.end = null
            this.getInvoices()
        }

        if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getInvoices()
        }else{
            this.invoices = []
        }

    },
    per_page(){
        this.getInvoices(this.page)
    },
    status(){
        this.getInvoices()
    },
    openCreateModal(){
        this.createModalStatus = this.openCreateModal
        this.create()
    },
    createModalisOpen(){
        this.$emit('createModalStatus',this.createModalisOpen)
    },
    async keyword(){
        if(this.keyword.length > 2){
            const response = await helper.customGet(`${process.env.VUE_APP_API}/credit-invoices?keyword=${this.keyword}&per_page=${this.per_page}`)
            this.invoices = response.data.data
            this.count = response.data.count
        }
        if(this.keyword == '') return this.getInvoices()
    },
  },    
  methods : {
    async create(){
        this.createModalisOpen = true;
            
        if(this.products && this.products.length){
            this.invoice.products = this.products
        }

         if(this.invoice_id){
            this.invoice.base_invoice_id = this.invoice_id
        }

        if(this.client_id){
            this.invoice.client_id = this.client_id
        }

        if(this.client){
            this.invoice.client = this.client
            this.invoice.client_id = this.client.id
        }

        if(this.order_id){
            this.invoice.order_id = this.order_id
        }


        this.invoice.products.push({
            label : '',
            id : null,
            quantity : 0,
            price : 0,
            discount : 0,
            vat : this.business.vat,
            total : 0,
            sub_total : 0,
            custom_product : false
        })

        this.invoice.date = moment().format('YYYY-MM-DD')
    },
    editRow(row){
        this.editModalisOpen = true;
        this.clearForm()
        this.invoice = row 
        this.invoice.client_id = row.client && row.client.id ? row.client.id : null
        this.invoice.date = moment(this.invoice.date).format('YYYY-MM-DD')
        // this.orderProducts = this.order.products
    },
    emitAutoCompleteOrder(data){
        this.invoice.products = data.result.products
        this.invoice.order_id = data.result.id
        this.invoice.client = data.result.client
        this.calculatePrices()
    },
    viewRow(row){
        this.clearForm()
        this.invoice = row 
        this.invoiceModalisOpen = true;
    },
    async deleteRow(row){
            this.$swal.fire({
            title: `${this.$t('are_you_sure')}?`,
            text : this.$t('you_cant_revert'),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: this.$t('yes_delete_it')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    await helper.customDelete(`${process.env.VUE_APP_API}/credit-invoices/${row.id}`)
                    this.invoices = helper.withoutDeletedRecords(this.invoices, row.id)
                    this.count = Math.max(0, this.count - 1)
                }
            })
    },
    clearForm(){
        this.invoice = {
            id : null,
            reference : '',
            date : '',
            products : [],
            payment_method : 'cash',
            status : 'draft',
            rest : 0,
            total : 0,
            amount_paid : 0,
            custom_product : false
        }
    },
    async getInvoices(page){
        try{
            this.loading = true
            this.page = page ? page : 1
            const params = new URLSearchParams({ page: this.page, per_page: this.per_page, status: this.status })
            this.appendSortParams(params)
            if (this.start) {
                params.append('start', this.start)
                params.append('end', this.end)
            }
            const filterKeys = ['client_id', 'order_id', 'inventory_id', 'product_id', 'user_id', 'invoice_id']
            filterKeys.forEach(key => {
                if (this[key]) params.append(key, this[key])
            })
            this.invoices = []

            if(this.keyword != "" && this.keyword != undefined){
                params.append('keyword', this.keyword)
            }
            const url = `${process.env.VUE_APP_API}/credit-invoices?${params.toString()}`
            const response = await helper.customGet(url)
            this.invoices = response.data.data
            this.count = response.data.count
            if(this.per_page != response.data.per_page){
                this.per_page = response.data.per_page
            }
            //pagination
            this.pagination = []
            let MaxPagination = Math.ceil(this.count / this.per_page )
            for(let i = 1 ; i <= MaxPagination ;i++){
                this.pagination.push(i)
            }
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    calculateItemPrice(invoice){
        if(invoice.status == "draft") return 0
        return invoice.products && invoice.products.length ? invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0; 
    },
    async editOrderStatus(invoice){
        try{
            this.loading = true
            await helper.customPatch(`${process.env.VUE_APP_API}/credit-invoices/${invoice.id}`,{status :invoice.status })
            this.clearForm()
            this.loading = false
        }catch(error){
            this.loading = false
        }

    },
    getStatus(status){
       if(status == 'paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'partially_paid'){
         return 'badge bg-success rounded-pill small'
       }else if(status == 'pending'){
         return 'badge bg-primary rounded-pill small'
       }else if(status == 'refunded'){
         return 'badge bg-info rounded-pill small'
       }
    },
    refresh(){
        this.getInvoices()
    },
    //helper functions
    formatDate(date,locale) { return helper.formatDate(date,locale) },
    formatMoney(number) { return helper.formatMoney(number);},
    formatReference(number,id) { return helper.formatReference(number,id);}
  },
  computed : {
    role(){ return this.$store.getters.ROLE },
    permissions(){ return this.$store.getters.PERMISSIONS },
    business(){ return this.$store.getters.BUSINESS},
    total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.total).reduce((a, c) => { return a + c }) : 0},
    sub_total(){ return this.invoice.products.length ? this.invoice.products.map(o => o.sub_total).reduce((a, c) => { return a + c }) : 0}
  }
}
</script>

<style scoped>
    .table-borderless>:not(caption)>*>*{
        padding: 5px !important
    }
</style>
